import axiosInstance from "../../api/auth/axiosInstance";

export const getBookingDoctors = async (userId) => {
  try {
    const response = await axiosInstance.get(`/booking-doctors/${userId}`, {
      headers: { authType: "PostLogin" }
    });

    return response.data.data; // BaseResponseOne -> data
  } catch (error) {
    console.error("Failed to fetch booking doctors", error);
    throw error;
  }
};

export const getBookingPatientLists = async (createdBy,companyId) => {
  try {
    const response = await axiosInstance.get(`/patients/patient-created-by-company/${createdBy}/${companyId}`, {
      headers: { authType: "PostLogin" }
    });

    return response; // BaseResponseOne -> data
  } catch (error) {
    console.error("Failed to fetch booking doctors", error);
    throw error;
  }
};